import React from 'react';
import { StarIcon } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    name: 'Carlos M.',
    text: 'Increíble trabajo. Mi coche quedó como nuevo, mejor que de fábrica. Totalmente recomendable.',
    date: 'Hace 2 semanas'
  }, {
    name: 'María L.',
    text: 'Profesionales de verdad. Me repararon un golpe lateral y no se nota absolutamente nada. Precio justo y rapidez.',
    date: 'Hace 1 mes'
  }, {
    name: 'Javier R.',
    text: 'Cambié el color de mi coche y el resultado es espectacular. Gran atención al detalle y trato excelente.',
    date: 'Hace 3 semanas'
  }, {
    name: 'Ana P.',
    text: 'El pulido dejó mi coche brillando como el primer día. Muy contentos con el servicio y la atención.',
    date: 'Hace 1 mes'
  }, {
    name: 'David S.',
    text: 'Restauraron los faros de mi coche y la diferencia es brutal. Rápido, económico y profesional.',
    date: 'Hace 2 meses'
  }, {
    name: 'Laura G.',
    text: 'Pintaron el paragolpes y quedó perfecto. Imposible notar la diferencia. Volveré seguro.',
    date: 'Hace 1 semana'
  }];
  return <section id="opiniones" className="bg-[#111827] py-24 relative overflow-hidden" data-id="element-210">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent" data-id="element-211"></div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <div className="inline-flex items-center justify-center space-x-2 mb-4" data-id="element-214">
            <div className="bg-white p-1.5 rounded-full" data-id="element-215">
              {/* Google G Logo SVG simulation */}
              <svg className="w-5 h-5" viewBox="0 0 24 24" data-id="element-216">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-217" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-218" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-219" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-220" />
              </svg>
            </div>
            <span className="text-gray-300 font-medium" data-id="element-221">Reseñas de Google</span>
          </div>

          <h2 className="text-3xl font-bold text-white sm:text-4xl" data-id="element-222">
            Lo que dicen nuestros clientes
          </h2>

          <div className="mt-6 flex items-center justify-center space-x-2" data-id="element-223">
            <span className="text-4xl font-bold text-white" data-id="element-224">4.9</span>
            <div className="flex" data-id="element-225">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-6 w-6 text-yellow-400 fill-yellow-400" data-id="element-226" />)}
            </div>
          </div>
          <p className="mt-2 text-sm text-gray-400" data-id="element-227">basado en 127 reseñas</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-228">
          {reviews.map((review, index) => <div key={index} className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-gray-500 transition-colors" data-id="element-229">
              <div className="flex items-center justify-between mb-4" data-id="element-230">
                <div className="flex items-center space-x-3" data-id="element-231">
                  <div className="h-10 w-10 rounded-full bg-gradient-to-br from-blue-500 to-red-600 flex items-center justify-center text-white font-bold text-lg" data-id="element-232">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-233">
                    <h4 className="text-white font-medium" data-id="element-234">{review.name}</h4>
                    <p className="text-xs text-gray-400" data-id="element-235">{review.date}</p>
                  </div>
                </div>
                <div className="flex" data-id="element-236">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" data-id="element-237" />)}
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-238">
                "{review.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}